import axios from 'axios';
import {
  REQUEST_SDK_TOKEN_GENERATION_SUCCESS,
  REQUEST_SDK_TOKEN_GENERATION_FAILED,

  REQUEST_CREATE_CHECK_SUCCESS,
  REQUEST_CREATE_CHECK_FAILED,

  REQUEST_VERIFICATIONS_STATUS_SUCCESS,
  REQUEST_VERIFICATIONS_STATUS_FAILURE,
  REQUEST_VERIFICATIONS_STATUS_BEGIN,
} from './types';

const baseURL = '/onfido';

export const generateSDKToken = () => async (dispatch) => {
  const url = `${baseURL}/verify`;

  try {
    const response = await axios.post(url);
    return dispatch({ type: REQUEST_SDK_TOKEN_GENERATION_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: REQUEST_SDK_TOKEN_GENERATION_FAILED, errors: error });
    }

    return dispatch({ type: REQUEST_SDK_TOKEN_GENERATION_FAILED });
  }
};

export const initiateChecks = () => async (dispatch) => {
  const url = `${baseURL}/verify`;

  try {
    const response = await axios.patch(url);
    return dispatch({ type: REQUEST_CREATE_CHECK_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: REQUEST_CREATE_CHECK_FAILED, errors: error });
    }

    return dispatch({ type: REQUEST_CREATE_CHECK_FAILED });
  }
}

export const checkStatus = () => async (dispatch) => {
  const url = `${baseURL}/status`;

  dispatch({ type: REQUEST_VERIFICATIONS_STATUS_BEGIN });

  try {
    const response = await axios.get(url);
    return dispatch({ type: REQUEST_VERIFICATIONS_STATUS_SUCCESS, payload: response.data });
  } catch (error) {
    if (error) {
      return dispatch({ type: REQUEST_VERIFICATIONS_STATUS_FAILURE, errors: error });
    }

    return dispatch({ type: REQUEST_VERIFICATIONS_STATUS_FAILURE });
  }
}